export const CSSKeys = Object.freeze({
    'font-family': 'fontFamily',
    'font-size': 'fontSize',
    'font-weight': 'fontWeight',
    'text-align': 'textAlign',
    'margin-bottom': 'marginBottom',
    'margin-left': 'marginLeft',
    'margin-right': 'marginRight',
    'margin-top': 'marginTop',
    'padding-bottom': 'paddingBottom',
    'padding-left': 'paddingLeft',
    'padding-right': 'paddingRight',
    'padding-top': 'paddingTop'
});

export const BlackListCSSKeys = Object.freeze({
    'display': 'display'
});

export const parseNodeStyles = styles => {
    if (typeof styles === 'object' ) {
        return styles;
    }

    const styleRules   = styles?.split(';');
    const parsedStyles = {};

    styleRules?.forEach(rule => {
        const splitRule = rule.split(':');
        let ruleName = splitRule[0];

        if(splitRule.length > 1 && !BlackListCSSKeys.hasOwnProperty(ruleName)) {
            if (CSSKeys.hasOwnProperty(ruleName)) {
                ruleName = CSSKeys[ruleName];
            }

            parsedStyles[ruleName] = splitRule[1].trim();
        }
    });

    return parsedStyles;
};

export const parseTextColors = val => {
    if (val.equals('text-white')) {
        return '#ffffff';
    }

    return '#000';
}
